import { limitRadiusWhenAllModelsSelected } from 'site-modules/shared/utils/inventory/srp-utils';
import { venomHistory } from 'client/utils/history/venom-history';
import { objectToQueryString } from 'site-modules/shared/utils/string';
import {
  filterAvailableSeoKeys,
  prepareQueryParamsMap,
  replaceToSeoKeys,
} from 'site-modules/shared/utils/inventory/params-conversion';
import { flow, omit } from 'lodash-es';

export function getPath({ pathname, query, filters }) {
  const getSrpQuery = flow(limitRadiusWhenAllModelsSelected, replaceToSeoKeys, prepareQueryParamsMap);
  const resultQuery = { ...omit(query, Object.keys(filterAvailableSeoKeys(query))), ...getSrpQuery(filters) };
  return `${pathname}?${objectToQueryString(resultQuery)}`;
}

export function addFiltersToQuery({ pathname, query, filters, useReplace }) {
  const path = getPath({ pathname, query, filters });

  if (useReplace) {
    venomHistory.replace(path);
  } else {
    venomHistory.push(path);
  }
}
